import { render } from "./GroupPermissionsSelector.vue?vue&type=template&id=2fa8c08a&scoped=true"
import script from "./GroupPermissionsSelector.vue?vue&type=script&lang=js"
export * from "./GroupPermissionsSelector.vue?vue&type=script&lang=js"

import "./GroupPermissionsSelector.vue?vue&type=style&index=0&id=2fa8c08a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa8c08a"]])

export default __exports__